<template>
  <div>
    <logged-in-header />
    <ferramentas />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import ferramentas from "../components/ferramentas/Ferramentas.vue";

export default {
  components: {
    loggedInHeader,
    ferramentas
  }
};
</script>
